import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Heart, Trophy, Clock } from "lucide-react";

interface GameHudProps {
  title: string;
  score: number;
  maxScore: number;
  lives: number;
  timeLeft: number;
  progress: number; // 0..100
  streak?: number;
}

export const GameHud = ({ title, score, maxScore, lives, timeLeft, progress, streak = 0 }: GameHudProps) => (
  <Card>
    <CardContent className="p-4">
      <div className="flex flex-wrap items-center gap-3 justify-between">
        <div className="flex items-center gap-2 min-w-0">
          <Badge variant="secondary" className="truncate max-w-[220px]">{title}</Badge>
        </div>
        <div className="flex items-center gap-4 text-sm">
          <span className="flex items-center gap-1"><Trophy className="h-4 w-4" /> {score}/{maxScore}</span>
          <span className="flex items-center gap-1"><Heart className="h-4 w-4 text-destructive" /> {lives}</span>
          <span className="flex items-center gap-1"><Clock className="h-4 w-4" /> {Math.max(0, Math.ceil(timeLeft))}s</span>
          {streak > 1 && <Badge>🔥 {streak}</Badge>}
        </div>
      </div>
      <Progress value={progress} className="mt-3 h-2" />
    </CardContent>
  </Card>
);
